import { useState } from "react"
import { useQuery } from "react-query"
import PaymentAccount from "../payment-account/model/paymentaccount"
import Location from "../state/location/Location"
import LocationService from "../state/location/LocationService"

const isLocationAvailable = (location: Location, paymentAccounts: PaymentAccount[] | undefined) => {
    const associatedAccount = paymentAccounts?.filter(pa => !pa.hasTestSandboxMerchantId())
        .find(pa => pa.getLocationIds().includes(location.getId()))
    return !associatedAccount && location.getEnabled()
}

export const useGetLocations = (paymentAccounts: PaymentAccount[] | undefined) => {

    const [availableLocations, setAvailableLocations] = useState<Location[]>([])
    const { data: locations, isLoading: isLoadingLocations } = useQuery(["getLocations", paymentAccounts], async () => {
        return LocationService.fetchAllLocations()
    }, {
        enabled: !!paymentAccounts,
        onSuccess: (locations) => {
            const availableLocations = locations.filter((location) => isLocationAvailable(location, paymentAccounts))
            setAvailableLocations(availableLocations)
        },
    })

    return {
        locations,
        isLoadingLocations,
        availableLocations,
    }
}


// WEBPACK FOOTER //
// ./src/payment-processing/useGetLocations.tsx